import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { apiService } from '@/service/api';

export default function FeedbackAttachment() {
  const { id } = useParams<{ id: string }>();
  const [file, setFile] = useState<{ url: string; filename: string; preview: boolean } | null>(
    null,
  );
  const [error, setError] = useState('');
  useEffect(() => {
    setFile(null);
    setError('');
    let disposed = false;
    let objectUrl: string | undefined;
    const controller = new AbortController();
    async function load() {
      try {
        if (!id) throw new Error('Missing attachment');
        const response = await apiService.fetchOrError(
          apiService.getUrl('v1/feedback/attachment/' + encodeURIComponent(id)),
          { signal: controller.signal },
        );
        const filename = decodeURIComponent(
          response.headers.get('Content-Disposition')?.split("filename*=UTF-8''")[1] ?? 'download',
        );
        const blob = await response.blob();
        if (disposed) return;
        objectUrl = URL.createObjectURL(blob);
        setFile({
          url: objectUrl,
          filename,
          preview: ['image/png', 'image/jpeg', 'image/gif', 'image/webp'].includes(blob.type),
        });
      } catch (cause) {
        if (!disposed)
          setError(cause instanceof Error ? cause.message : 'Could not load attachment');
      }
    }
    void load();
    return () => {
      disposed = true;
      controller.abort();
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [id]);
  return (
    <main className="mx-auto max-w-xl p-8">
      <h1 className="text-xl font-semibold">Report attachment</h1>
      {error ? (
        <p role="alert" className="mt-4">
          {error}
        </p>
      ) : file ? (
        <div>
          {file.preview && <img className="mt-4 max-w-full" src={file.url} alt={file.filename} />}
          <a className="mt-4 inline-block underline" href={file.url} download={file.filename}>
            Download {file.filename}
          </a>
        </div>
      ) : (
        <p className="mt-4">Loading attachment…</p>
      )}
    </main>
  );
}
